import { render, staticRenderFns } from "./IlloHouseRooms.vue?vue&type=template&id=74fdc271"
import script from "./IlloHouseRooms.vue?vue&type=script&lang=js"
export * from "./IlloHouseRooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports